/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Hyperlink: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M13.2632 7.11683L11.4193 5.27294C9.72201 3.57568 6.9702 3.57568 5.27294 5.27295C3.57569 6.97021 3.57569 9.722 5.27294 11.4193L7.11684 13.2632M8.21053 8.21053L15.7895 15.7895M10.7368 16.8832L12.5807 18.7271C14.278 20.4243 17.0298 20.4243 18.7271 18.7271C20.4243 17.0298 20.4243 14.278 18.7271 12.5807L16.8832 10.7368'
      stroke='#1E1E1E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </React.Fragment>
)
